module.exports = __webpack_public_path__ + "img/bask_right_nor.4f36a311.png";